import { InfositeController } from './infosite-controller';

export class InfositeControllerExtended extends InfositeController {
  public path = '/Cruises:prefix([^?#]+)Cruise-Information';
}